// extracted by mini-css-extract-plugin
module.exports = {"cmsMenu":"_a55d201","menuItem":"_2f39014","buttonLink":"_082182f","active":"_6c3f08a","noActiveStyle":"_e82e052","menuLink":"_94c4192","icon":"_5b7c0a6"};